import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from "@angular/router";
import { Auth } from "aws-amplify";
import { sntLog } from "src/app/common/logger";

const logger = sntLog("AuthenticateWithTokenGuard");

@Injectable()
export class AuthenticateWithTokenGuard implements CanActivate {
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    logger.debug("canActivate");

    const token = route.queryParamMap.get("token");

    if (!token) {
      return true;
    }

    try {
      const decodedToken = atob(token);

      const username = decodedToken.split(":")[0];
      const password = decodedToken.split(":")[1];

      if (!!username && !!password) {
        await Auth.signIn(username, password);
      }
    } catch (ex) {
      console.error(ex);
    }

    return true;
  }
}
